import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, nextTick, ref, watch } from "vue";
import { API_BIS_PATENT_SINGLECATEGORY } from "@/configs/Apis";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import DuduAjax from "@/utils/DuduAjax";
import cloneDeep from "lodash/cloneDeep";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentCategory',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
  treeData: { default: () => "", type: String },
},
  setup(__props) {

const props = __props;



const store = useStore();

const loading = ref(false);
const treeProps = { label: "name", children: "children" };

const staticTreeData = computed(() => {
  const categoryTree = cloneDeep((store.state as any).project.customCategoryTree);
  categoryTree.forEach((item: any) => (item.disabled = true));
  return categoryTree;
});

const tree = ref<any>(null);
const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

function setTreeChecked() {
  const nodes: Array<any> = [];
  if (props.patent.patentCategoryList && props.patent.patentCategoryList.length) {
    nodes.push(...props.patent.patentCategoryList.map((item: any) => item.categoryId));
  }
  nextTick(() => tree.value && tree.value.setCheckedKeys(nodes));
}

function saveCategory() {
  if (!staticTreeData.value || !staticTreeData.value.length) {
    showWarning("没有自定义分类树，请先创建分类");
    return;
  }
  const selectedNodes: Array<any> = tree.value.getCheckedNodes();
  if (!selectedNodes || !selectedNodes.length) {
    showWarning("请选择一个分类");
    return;
  }
  showConfirm("是否保存分类").then(async () => {
    const patent = props.patent as any;
    const postedData: Array<string[]> = [];
    postedData.push(...selectedNodes.map((node) => node.id));
    try {
      loading.value = true;
      await DuduAjax.post(
        { url: API_BIS_PATENT_SINGLECATEGORY, path: { projectId } },
        { patentId: props.patent.id, categoryIdList: postedData }
      );
      showSuccess("保存成功");
      await store.dispatch("project/getCustomCategoryData");
      if (!Object.hasOwn(patent, "patentCategoryList")) {
        patent.patentCategoryList = [];
      }
      patent.patentCategoryList.length = 0;
      patent.patentCategoryList.push(...selectedNodes.map((node) => ({ categoryId: node.id })));
    } finally {
      loading.value = false;
    }
  });
}

watch(
  () => props.patent,
  () => {
    setTreeChecked();
  }
);
setTreeChecked();

return { __sfc: true,props, store, loading, treeProps, staticTreeData, tree, projectId, setTreeChecked, saveCategory }
}

})